/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserContextOutputCurrentModule } from './userContextOutputCurrentModule';
import type { UserContextOutputActivity } from './userContextOutputActivity';

/**
 * Shows what the user is currently working on
Projection of the last activities
 */
export interface UserContextOutput {
  currentModule?: UserContextOutputCurrentModule;
  activity?: UserContextOutputActivity;
}
